<template>
  <v-dialog
    persistent
    max-width="980"
    v-model="dialog"
    >
      <template #activator="{on}">
        <v-btn v-on="on" color="success" outlined>
            <v-icon left>mdi-check</v-icon>
            Receive
        </v-btn>
      </template>
      <v-card :loading="loading">
          <v-card-title>Receive {{ product ? product.name : '' }}</v-card-title>
          <v-card-text v-if="product" class="text--primary">
              <v-container fluid>
                  <v-row>
                      <v-col cols="6">
                          <div class="text-capitalize overline text--secondary">Name</div>
                          {{product.name}}
                      </v-col>
                      <v-col cols="6">
                          <div class="text-capitalize overline text--secondary">Code</div>
                          {{product.code}}
                      </v-col>
                  </v-row>
                  <v-row>
                      <v-col cols="6">
                          <div class="text-capitalize overline text--secondary">Ordered Quantity</div>
                          {{item.quantity}}
                      </v-col>
                      <v-col cols="6">
                          <div class="text-capitalize overline text--secondary">Received Quantity</div>
                          {{item.received ? item.received : 0}}
                      </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6">
                        <div class="text-capitalize overline text--secondary">Unit cost for stock</div>
                        {{product.cost | currency(product.costCurrency)}}
                    </v-col>
                    <v-col cols="6">
                        <v-form ref="unitCostForm">
                            <v-text-field
                                label="Unit cost for this PO"
                                v-model="item.cost"
                                :rules="[greaterThanZero]"
                                :prefix="currency"
                            />
                        </v-form>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                        <v-card>
                            <v-card-title>Dispatch received quantity</v-card-title>
                            <v-card-text>
                                <v-alert type="error" v-if="remainStock<0">To many product to dispatch</v-alert>
                                <v-simple-table v-if="currentLocations.length">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="text-left">
                                                    Location
                                                </th>
                                                <th class="text-left">
                                                    Current Stock
                                                </th>
                                                <th class="text-left">
                                                    Received quantity
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="location in currentLocations" :key="'loc_'+location.id">
                                                <td>{{location.location}}</td>
                                                <td>{{location.currentStock}}</td>
                                                <td>
                                                    <v-text-field v-model="location.quantity" :disabled="loading" :hint="'Remain '+remainStock+' to dispatch'"></v-text-field>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                                <v-row>
                                    <v-col cols="12" class="d-flex justify-center">
                                        <add-location v-if="!loading && remainStock>0"  :warehouse="warehouse.id" :remain="remainStock" @add-location="addLocation($event)"/>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                        
                    </v-col>
                  </v-row>
              </v-container>
          </v-card-text>
          <v-card-actions>
              <v-btn @click="close" outlined :disabled="loading">Cancel</v-btn>
              <v-spacer />
              <v-btn @click="receive" color="success" :disabled="loading || remainStock<0 || dispatched == 0">{{remainStock ? 'Partially Receive':'Receive'}}</v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import AddLocation from './AddLocation.vue';
export default {
  components: { AddLocation },
    data: () => ({
        loading:false,
        dialog: false,
        activeLine:0,
        maxLine:0,
        product:null,
        currentLocations:[],
        greaterThanZero: (v) => v>0 || 'Should be greater than zero'
    }),
    props:{
        warehouse: {
            type: Object,
            required: true
        },
        poId: {
            type: Number,
            required: true
        },
        item: {
            type: Object,
            required:true
        },
        currency: {
            type: String,
            required: true
        }
    },
    watch:{
        dialog(v){
            if(v){
                this.getLineDetail();
            }
        }
    },
    computed:{
        dispatched(){
            return this.currentLocations.reduce( function(a, b){
                return a + parseInt(b.quantity);
            }, 0);
        },
        remainStock(){
            return this.item ? parseInt(this.item.quantity ?? 0) - parseInt(this.item.received ?? 0) - this.dispatched:0;
        },
    },
    methods:{
        ...mapActions('purchaseOrders',['receiveProduct']),
        ...mapActions('products',{getProducts:'get', getLocations:'getLocations'}),
        getLineDetail(){
            this.loading = true;
            this.product = null
            this.currentLocations = []
            this.getProducts({id:this.item.product_id})
            .then(({data})=>{
                this.product = data;
                this.getLocations({id:this.item.product_id})
                .then(({locations})=>{
                    this.currentLocations = locations.map(location=>{
                        return {
                            id:location.location.id,
                            location:location.location.location,
                            currentStock:location.final,
                            quantity:0
                        }
                    })
                })
            })
            .finally(()=>{
                this.loading = false;
            })
        },
        addLocation(location){
            this.currentLocations.push(location);
        },
        receive(){
            if(this.$refs.unitCostForm.validate()){
                this.loading = true;
                this.receiveProduct({
                    poId:this.poId,
                    productId:this.item.product_id,
                    locations:this.currentLocations,
                    cost: this.item.cost
                }).then(() => {
                    this.close();
                }).finally(()=>{
                    this.loading = false;
                })
            }
        },
        close(){
            this.dialog=false
            this.activeLine = 0
            this.maxLine = 0
            this.product = null
            this.$emit("received")
        },
        openOnLine(line){
            this.activeLine = line
            this.dialog = true
        }
    }
}
</script>

<style>

</style>